import { render } from "./time-off.vue?vue&type=template&id=0c5803fa&scoped=true"
import script from "./time-off.vue?vue&type=script&lang=js"
export * from "./time-off.vue?vue&type=script&lang=js"

import "./time-off.vue?vue&type=style&index=0&id=0c5803fa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5803fa"]])

export default __exports__